import { render, staticRenderFns } from "./DraftInvoices.vue?vue&type=template&id=52023c28&scoped=true"
import script from "./DraftInvoices.vue?vue&type=script&lang=js"
export * from "./DraftInvoices.vue?vue&type=script&lang=js"
import style0 from "./DraftInvoices.vue?vue&type=style&index=0&id=52023c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52023c28",
  null
  
)

export default component.exports